import React from "react"
import SbEditable from "storyblok-react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import { StoryblokForm } from "./StoryblokForm"

const Form = ({ isDark, formUuid, name }) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokEntry(
          filter: { 
            full_slug: { 
              regex: "/^hult/config/forms/" 
            } 
          }
        ) {
          edges {
            node {
              uuid
              content
              name
            }
          }
        }
      }
    `}
    render={(data) => {
      let form
      if (data && data.allStoryblokEntry) {
        data.allStoryblokEntry.edges.filter((e) => {
          if (e.node.uuid === formUuid) {
            const block = JSON.parse(e.node.content)
            return (form = <StoryblokForm formId={e.node.uuid} name={e.node.name} isDark={isDark} key={e.node.uuid} blok={block} />)
          }
          return form
        })
      }
      return form
    }}
  />
)

export const StoryblokFormWrapper = ({ isDark, blok, name, key }) => {
  return (
    <SbEditable content={blok}>
      <div>{blok.form && <Form name={name} isDark={isDark} key={key} formUuid={blok.form} />}</div>
    </SbEditable>
  )
}

StoryblokFormWrapper.defaultProps = {
  isDark: false,
  name: "",
}
StoryblokFormWrapper.propTypes = {
  blok: PropTypes.shape({}),
  name: PropTypes.string
}
